import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sun } from "lucide-react";
import wpPosts from "../data/wpPosts.json";
import placeholderImage from "../assets/solarservice.jpeg";

// The article used to dead-end: reader finishes, page stops. These two cards
// give it somewhere to go -- one commercial, one editorial.

export const BlogCtaCard = () => (
  <div className="rounded-2xl border border-[#dfeadf] bg-[#f1f8f1] p-6 shadow-sm">
    <div className="mb-3 flex items-center gap-2">
      <Sun size={20} className="text-[#f5a524]" aria-hidden="true" />
      <p className="text-[17px] font-bold leading-snug text-[#111827]">
        Want better solar performance?
      </p>
    </div>
    <p className="mb-5 text-[14px] leading-relaxed text-[#4b5563]">
      Get expert advice, system checkups and maintenance support from Savorka
      Solar.
    </p>
    <Link
      to="/contact"
      className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#117816] px-5 py-3 text-[14px] font-semibold text-white transition hover:opacity-90"
    >
      Contact our experts
      <ArrowRight size={16} aria-hidden="true" />
    </Link>
  </div>
);

/**
 * Every post is currently filed under one category ("Solar Guide"), so
 * "related" cannot mean "same topic" without inventing a taxonomy. It means
 * the most recent other posts -- honest, and it stays correct if categories
 * are split up later.
 */
export const BlogRelated = ({ currentSlug, limit = 3 }) => {
  const related = wpPosts
    .filter((post) => post.slug !== currentSlug)
    .sort((a, b) => new Date(b.dateIso) - new Date(a.dateIso))
    .slice(0, limit);

  if (!related.length) return null;

  return (
    <div className="rounded-2xl border border-[#edf1ed] bg-white p-6 shadow-sm">
      <p className="mb-4 text-[12px] font-bold uppercase tracking-[0.14em] text-[#117816]">
        Related articles
      </p>
      <ul className="space-y-4">
        {related.map((post) => (
          <li key={post.slug}>
            <Link to={`/blogs/${post.slug}`} className="group flex gap-3">
              <img
                src={post.thumbnail || post.image || placeholderImage}
                alt=""
                aria-hidden="true"
                width="64"
                height="36"
                loading="lazy"
                decoding="async"
                className="h-[46px] w-[64px] shrink-0 rounded-lg object-cover"
              />
              <span className="min-w-0">
                <span className="block text-[14px] font-medium leading-snug text-[#374151] transition-colors group-hover:text-[#117816]">
                  {post.title}
                </span>
                <span className="mt-1 block text-[12px] text-[#9ca3af]">
                  {post.readTime}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
